<template>
  <selector-container v-if="!isEmpty" label="Colas" selected-label="Seleccionadas" :height="height">
    <template v-slot:left>
      <a-input-search v-model:value="search" placeholder="Buscar por nombre" size="small" />

      <div v-for="item in filteredItems" :key="item.id" class="field">
        <a-checkbox :checked="isActive(item)" @change="handleToggle(item)">
          {{ item.name }}
        </a-checkbox>
      </div>
    </template>

    <template v-slot:right>
      <div class="block__item">
        <span>Cola general</span>
      </div>
      <div v-for="item in items" :key="item.id">
        <div v-if="isActive(item)" class="block__item">
          <span>{{ item.name }}</span>
          <!-- <a-icon class="block__icon" type="close" @click="handleRemove(item)" /> -->
          <CloseOutlined class="block__icon" @click="handleRemove(item)" />
        </div>
      </div>
    </template>
  </selector-container>
</template>

<script>
import { fetchAllQueues } from "@/app/queues/services";
import SelectorContainer from "@/app/shared/components/selectors/SelectorContainer.vue";
import { filterArrayByText } from "@/app/shared/utils/helpers";
import { defineComponent } from "vue";
import { CloseOutlined } from "@ant-design/icons-vue";

export default defineComponent({
  components: {
    SelectorContainer,
    CloseOutlined,
  },
  props: {
    value: { required: true, type: Array },
    height: { required: false, type: Number, default: 320 },
  },
  data() {
    return {
      search: "",
      items: [],
    };
  },
  computed: {
    filteredItems() {
      return filterArrayByText(this.search, this.items);
    },
    selectedQueues: {
      get() {
        return this.value;
      },
      set(value) {
        const campaigns = value.sort();
        this.$emit("update:value", campaigns);
        this.$emit("change", campaigns);
      },
    },
    isEmpty() {
      return !this.items || this.items.length === 0;
    },
  },
  mounted() {
    this.fetchQueues();
  },
  methods: {
    async fetchQueues() {
      const queues = await fetchAllQueues();
      this.items = queues.results;
    },
    isArrayEmpty(array) {
      return !array || array.length === 0;
    },
    isActive(item) {
      return this.selectedQueues.includes(item.id);
    },
    handleToggle(item) {
      if (this.isActive(item)) {
        this.handleRemove(item);
      } else {
        this.selectedQueues = [...this.selectedQueues, item.id];
      }
    },
    handleRemove(item) {
      this.selectedQueues = this.selectedQueues.filter((element) => element !== item.id);
    },
  },
});
</script>

<style lang="sass" scoped>
.field
  color: $gray-8
  padding-top: 8px

.label
  font-weight: 600
  margin: 8px 0

.block
  margin-bottom: 12px

  &__label
    margin: 8px 0 0 0

  &__item
    font-size: 12px
    display: flex
    align-items: center
    justify-content: space-between
    background-color: $blue-1
    border: 1px solid $blue-3
    border-radius: 2px
    padding: 2px 8px
    margin: 4px 0

  &__icon
    font-size: 10px
</style>
